import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'onefaceui-react-components';

const formatDate = (date) => Monet.Format.DateTime.formatToLocale(date);

const formatDateText = (baseline, actual) => {
  const isValidDate = (date) => date && date !== '--' && !Number.isNaN(new Date(date).getTime());

  const baselineText = isValidDate(baseline) ? formatDate(baseline) : '--';
  const actualText = isValidDate(actual) ? formatDate(actual) : '--';

  return `${baselineText} | ${actualText}`;
};

const formatTime = (serviceTimeSecs) => {
  let seconds = '';
  let minutes = '';
  let hours = '';
  const result = serviceTimeSecs;
  let strResult = '';
  if (result > 0) {
    seconds = result % 60;
    minutes = parseInt((result % 3600) / 60, 10);
    hours = parseInt(result / 3600, 10);
    if (hours > 0) {
      strResult = hours + Monet.I18n.getResourcesByKey('Greenmile.UnitMetrics.hourAbreviation');
    }
    if (minutes > 0) {
      strResult += ` ${minutes}${Monet.I18n.getResourcesByKey('Greenmile.UnitMetrics.minuteAbreviation')}`;
    }
    if (seconds > 0) {
      strResult += ` ${seconds}${Monet.I18n.getResourcesByKey('Greenmile.UnitMetrics.secondsAbreviation')}`;
    }
  } else if (result === 0) {
    strResult = '0';
  }
  return strResult.trim();
};

const formatTimeText = (planned, actual) => (`${planned && formatTime(planned)}
  ${actual !== 'undefined' ? '|' : ''}
  ${actual !== 'undefined' ? formatTime(actual) : ''
  }`);

function Times({ stop }) {
  const baselineArrival = stop.getIn(['serviceTimes', 'baselineArrival']) || '--';
  const actualArrival = stop.getIn(['serviceTimes', 'actualArrival']) || '--';

  const baselineDeparture = stop.getIn(['serviceTimes', 'baselineDeparture']) || '--';
  const actualDeparture = stop.getIn(['serviceTimes', 'actualDeparture']) || '--';

  const actualService = stop.getIn(['serviceTimes', 'actualService']) || '--';
  const baselineService = stop.getIn(['serviceTimes', 'baselineService']) || '--';

  const timeDeviationSecs = stop.getIn(['serviceTimes', 'timeDeviationSecs']);
  const serviceTimeSecs = stop.getIn(['serviceTimes', 'serviceTimeSecs']);
  const plannedTimeSecs = stop.getIn(['serviceTimes', 'plannedTimeSecs']);

  return (
    <>
      <Flex
        title={Monet.I18n.getResourcesByKey('Stop.popup.Title.AdjustedBaselineActualTime')}
        justifyContent="space-between"
        alignItems="center"
        className="times-item"
      >
        <div>{Monet.I18n.getResourcesByKey('Stop.popup.arrival')}</div>
        <div>{formatDateText(baselineArrival, actualArrival)}</div>
      </Flex>

      <Flex
        title={Monet.I18n.getResourcesByKey('Stop.popup.Title.AdjustedBaselineActualTime')}
        justifyContent="space-between"
        alignItems="center"
        className="times-item"
      >
        <div>{Monet.I18n.getResourcesByKey('Stop.popup.serviceStart')}</div>
        <div>{formatDateText(baselineService, actualService)}</div>
      </Flex>

      <Flex
        title={Monet.I18n.getResourcesByKey('Stop.popup.Title.AdjustedBaselineActualTime')}
        justifyContent="space-between"
        alignItems="center"
        className="times-item"
      >
        <div>{Monet.I18n.getResourcesByKey('Stop.popup.departure')}</div>
        <div>{formatDateText(baselineDeparture, actualDeparture)}</div>
      </Flex>

      <Flex
        title={Monet.I18n.getResourcesByKey('Stop.popup.Title.AdjustedActualTime')}
        justifyContent="space-between"
        alignItems="center"
        className="times-item"
        shouldShow={!!serviceTimeSecs}
      >
        <div>{Monet.I18n.getResourcesByKey('Stop.popup.timeStop')}</div>
        <div>{formatTimeText(plannedTimeSecs, serviceTimeSecs)}</div>
      </Flex>

      <Flex
        title={Monet.I18n.getResourcesByKey('Stop.popup.Title.Difference')}
        justifyContent="space-between"
        alignItems="center"
        className="times-item"
      >
        <div>{Monet.I18n.getResourcesByKey('Stop.popup.percent')}</div>
        <div>{formatTime(Math.abs(timeDeviationSecs))}</div>
      </Flex>
    </>
  );
}

Times.propTypes = {
  stop: PropTypes.object.isRequired
};

export default Times;
